module.exports = __webpack_public_path__ + "img/bitgo.97df3c21.png";